import '@/scss/pages/courses/courses.scss';
import {faq} from "@/js/global/components/faq";
import {coursesCategoryFilter} from "@/js/pages/courses/components/coursesCategoryFilter";
import {showMoreCategories} from "@/js/pages/courses/components/showMoreCategories";


window.addEventListener('load', () => {
    coursesCategoryFilter();
    showMoreCategories();
    faq();
});